import React from "react";
import CommonSection from "../../components/common-section/CommonSection";
import { postAppeal } from "../../redux/actions/actions";
import InputMask from "react-input-mask";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

export default function Appeal() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone_number, setPhoneNumber] = useState("");
  const [message, setMessage] = useState("");
  const [userType, setUserType] = useState(1);
  const [appealType, setAppealType] = useState(1);
  const [branch, setBranch] = useState(1);
  const [address, setAddress] = useState("");
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");

  const { location } = useSelector((state) => state.location);

  const fileChange = (e) => {
    let file = e.target.files[0];
    let formData = new FormData();
    formData.append("file", file);
    for (let key of formData.entries()) {
      console.log(key + ", " + key);
    }
    setFile(file);
    setFileName(file.name);
  };

  return (
    <section className="">
      <CommonSection title={location === "uz" ? "Murojaat" : "Обращение"} />

      <div className="container flex mx-auto items-start py-8">
        <div className="w-1/4 pr-5 lg:hidden">
          <h3 className="text-xl text-logo font-semibold mb-8">{location === "uz" ? "Murojaat" : "Обращение"}</h3>

          <div className="flex gap-3 c-col pb-4 border-b border-bd mr-5 mb-5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
            >
              <path
                d="M9.36556 10.6821C10.302 12.3288 11.6712 13.698 13.3179 14.6344L14.2024 13.3961C14.4965 12.9845 15.0516 12.8573 15.4956 13.0998C16.9024 13.8683 18.4571 14.3353 20.0789 14.4637C20.599 14.5049 21 14.9389 21 15.4606V19.9234C21 20.4361 20.6122 20.8657 20.1022 20.9181C19.5723 20.9726 19.0377 21 18.5 21C9.93959 21 3 14.0604 3 5.5C3 4.96227 3.02742 4.42771 3.08189 3.89776C3.1343 3.38775 3.56394 3 4.07665 3H8.53942C9.0611 3 9.49513 3.40104 9.5363 3.92109C9.66467 5.54288 10.1317 7.09764 10.9002 8.50444C11.1427 8.9484 11.0155 9.50354 10.6039 9.79757L9.36556 10.6821ZM6.84425 10.0252L8.7442 8.66809C8.20547 7.50514 7.83628 6.27183 7.64727 5H5.00907C5.00303 5.16632 5 5.333 5 5.5C5 12.9558 11.0442 19 18.5 19C18.667 19 18.8337 18.997 19 18.9909V16.3527C17.7282 16.1637 16.4949 15.7945 15.3319 15.2558L13.9748 17.1558C13.4258 16.9425 12.8956 16.6915 12.3874 16.4061L12.3293 16.373C10.3697 15.2587 8.74134 13.6303 7.627 11.6707L7.59394 11.6126C7.30849 11.1044 7.05754 10.5742 6.84425 10.0252Z"
                fill="rgba(14,14,75,1)"
              ></path>
            </svg>
            <dl className="flex flex-col gap-3">
              <dt className="font-medium text-lg text-logo">{t('phone')}</dt>
              <dd className="font-medium text-lg w-72">+998 71 208 82 39</dd>
              {/* <dd className="font-medium text-lg w-72">+998 71 208 05 14</dd> */}
            </dl>
          </div>

          <div className="flex gap-3 c-col pb-4 border-b border-bd mr-5 mb-5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
            >
              <path
                d="M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM20 7.23792L12.0718 14.338L4 7.21594V19H20V7.23792ZM4.51146 5L12.0619 11.662L19.501 5H4.51146Z"
                fill="rgba(14,14,75,1)"
              ></path>
            </svg>
            <dl className="flex flex-col gap-3">
              <dt className="font-medium text-lg text-logo">{t("email")}</dt>
              {/* <dd className="font-medium text-lg w-72">anticor@unicon.uz</dd> */}
              <dd className="font-medium text-lg w-72">b.yunusov@unicon.uz</dd>
            </dl>
          </div>

          <div className="flex gap-3 c-col pb-4 border-b border-bd mr-5 mb-5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
            >
              <path
                d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM9.71002 19.6674C8.74743 17.6259 8.15732 15.3742 8.02731 13H4.06189C4.458 16.1765 6.71639 18.7747 9.71002 19.6674ZM10.0307 13C10.1811 15.4388 10.8778 17.7297 12 19.752C13.1222 17.7297 13.8189 15.4388 13.9693 13H10.0307ZM19.9381 13H15.9727C15.8427 15.3742 15.2526 17.6259 14.29 19.6674C17.2836 18.7747 19.542 16.1765 19.9381 13ZM4.06189 11H8.02731C8.15732 8.62577 8.74743 6.37407 9.71002 4.33256C6.71639 5.22533 4.458 7.8235 4.06189 11ZM10.0307 11H13.9693C13.8189 8.56122 13.1222 6.27025 12 4.24799C10.8778 6.27025 10.1811 8.56122 10.0307 11ZM14.29 4.33256C15.2526 6.37407 15.8427 8.62577 15.9727 11H19.9381C19.542 7.8235 17.2836 5.22533 14.29 4.33256Z"
                fill="rgba(14,14,75,1)"
              ></path>
            </svg>
            <dl className="flex flex-col gap-3">
              <dt className="font-medium text-lg text-logo">{t("web_site")}</dt>
              <dd className="font-medium text-lg w-72">
                <a href="https://certificate.unicon.uz/">certificate.unicon.uz</a>
              </dd>
            </dl>
          </div>

          <div className="flex gap-3 c-col pb-4 border-b border-bd mr-5 mb-5">
            <svg
              width="24"
              height="24"
              viewBox="0 0 26 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M25.1772 23.5326L23.4001 18.2H21.4501L22.533 23.4H3.46724L4.55014 18.2H2.60014L0.821743 23.5326C0.370643 24.8898 1.17014 26 2.60014 26H23.4001C24.8301 26 25.6296 24.8898 25.1772 23.5326ZM19.5001 6.5C19.5001 4.77609 18.8153 3.12279 17.5963 1.90381C16.3774 0.684819 14.7241 0 13.0001 0C11.2762 0 9.62294 0.684819 8.40395 1.90381C7.18496 3.12279 6.50014 4.77609 6.50014 6.5C6.50014 12.7075 13.0001 19.5 13.0001 19.5C13.0001 19.5 19.5001 12.7075 19.5001 6.5ZM9.49014 6.578C9.49014 6.11712 9.58094 5.66076 9.75735 5.23498C9.93376 4.8092 10.1923 4.42234 10.5183 4.09651C10.8442 3.77068 11.2312 3.51226 11.657 3.33601C12.0829 3.15976 12.5393 3.06913 13.0001 3.0693C13.9309 3.0693 14.8235 3.43903 15.4816 4.09716C16.1398 4.7553 16.5095 5.64791 16.5095 6.57865C16.5095 7.50939 16.1398 8.402 15.4816 9.06013C14.8235 9.71827 13.9309 10.088 13.0001 10.088C12.0692 10.088 11.1765 9.7182 10.5182 9.05994C9.85995 8.40169 9.49014 7.50891 9.49014 6.578Z"
                fill="#0E0E4B"
              />
            </svg>
            <dl className="flex flex-col gap-3">
              <dt className="font-medium text-lg text-logo">
                {t("personal_appeal")}
              </dt>
              <dd className="font-medium text-lg w-72">
                {t("address_footer")}
              </dd>
            </dl>
          </div>

          <div>
            <p className="font-medium text-lg text-logo mb-5">
              {t("social_media")}
            </p>
            <div className="flex gap-2 c-col">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
              >
                <path
                  d="M12.001 20C16.4193 20 20.001 16.4183 20.001 12C20.001 7.58172 16.4193 4 12.001 4C7.5827 4 4.00098 7.58172 4.00098 12C4.00098 16.4183 7.5827 20 12.001 20ZM12.001 22C6.47813 22 2.00098 17.5228 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22ZM8.89113 13.1708L6.39308 12.3911C5.85317 12.2255 5.84996 11.854 6.51397 11.5871L16.247 7.82754C16.8115 7.59644 17.1325 7.88842 16.9495 8.61641L15.2917 16.4377C15.1763 16.9941 14.8407 17.1266 14.3759 16.8698L11.825 14.9823L10.6361 16.1297C10.5139 16.2476 10.4145 16.3489 10.2273 16.3743C10.04 16.3996 9.88564 16.3442 9.77337 16.0337L8.90378 13.1628L8.89113 13.1708Z"
                  fill="rgba(70,146,221,1)"
                ></path>
              </svg>
              <dl className="flex flex-col gap-3">
                <dt className="font-bold text-lg mb-3">
                  <a target="_blank" href="https://t.me/uniconcompany">
                    Telegram
                  </a>
                </dt>
              </dl>
            </div>
            <div className="flex gap-2 c-col">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
              >
                <path
                  d="M12.001 2C6.47813 2 2.00098 6.47715 2.00098 12C2.00098 16.9913 5.65783 21.1283 10.4385 21.8785V14.8906H7.89941V12H10.4385V9.79688C10.4385 7.29063 11.9314 5.90625 14.2156 5.90625C15.3097 5.90625 16.4541 6.10156 16.4541 6.10156V8.5625H15.1931C13.9509 8.5625 13.5635 9.33334 13.5635 10.1242V12H16.3369L15.8936 14.8906H13.5635V21.8785C18.3441 21.1283 22.001 16.9913 22.001 12C22.001 6.47715 17.5238 2 12.001 2Z"
                  fill="rgba(70,146,221,1)"
                ></path>
              </svg>
              <dl className="flex flex-col gap-3">
                <dt className="font-bold text-lg mb-3">
                  <a
                    target="_blank"
                    without
                    rel="noreferrer"
                    href="https://www.facebook.com/uniconuz"
                  >
                    Facebook
                  </a>
                </dt>
              </dl>
            </div>
            <div className="flex gap-2 c-col">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
              >
                <path
                  d="M12.001 9C10.3436 9 9.00098 10.3431 9.00098 12C9.00098 13.6573 10.3441 15 12.001 15C13.6583 15 15.001 13.6569 15.001 12C15.001 10.3427 13.6579 9 12.001 9ZM12.001 7C14.7614 7 17.001 9.2371 17.001 12C17.001 14.7605 14.7639 17 12.001 17C9.24051 17 7.00098 14.7629 7.00098 12C7.00098 9.23953 9.23808 7 12.001 7ZM18.501 6.74915C18.501 7.43926 17.9402 7.99917 17.251 7.99917C16.5609 7.99917 16.001 7.4384 16.001 6.74915C16.001 6.0599 16.5617 5.5 17.251 5.5C17.9393 5.49913 18.501 6.0599 18.501 6.74915ZM12.001 4C9.5265 4 9.12318 4.00655 7.97227 4.0578C7.18815 4.09461 6.66253 4.20007 6.17416 4.38967C5.74016 4.55799 5.42709 4.75898 5.09352 5.09255C4.75867 5.4274 4.55804 5.73963 4.3904 6.17383C4.20036 6.66332 4.09493 7.18811 4.05878 7.97115C4.00703 9.0752 4.00098 9.46105 4.00098 12C4.00098 14.4745 4.00753 14.8778 4.05877 16.0286C4.0956 16.8124 4.2012 17.3388 4.39034 17.826C4.5591 18.2606 4.7605 18.5744 5.09246 18.9064C5.42863 19.2421 5.74179 19.4434 6.17187 19.6094C6.66619 19.8005 7.19148 19.9061 7.97212 19.9422C9.07618 19.9939 9.46203 20 12.001 20C14.4755 20 14.8788 19.9934 16.0296 19.9422C16.8117 19.9055 17.3385 19.7996 17.827 19.6106C18.2604 19.4423 18.5752 19.2402 18.9074 18.9085C19.2436 18.5718 19.4445 18.2594 19.6107 17.8283C19.8013 17.3358 19.9071 16.8098 19.9432 16.0289C19.9949 14.9248 20.001 14.5389 20.001 12C20.001 9.52552 19.9944 9.12221 19.9432 7.97137C19.9064 7.18906 19.8005 6.66149 19.6113 6.17318C19.4434 5.74038 19.2417 5.42635 18.9084 5.09255C18.573 4.75715 18.2616 4.55693 17.8271 4.38942C17.338 4.19954 16.8124 4.09396 16.0298 4.05781C14.9258 4.00605 14.5399 4 12.001 4ZM12.001 2C14.7176 2 15.0568 2.01 16.1235 2.06C17.1876 2.10917 17.9135 2.2775 18.551 2.525C19.2101 2.77917 19.7668 3.1225 20.3226 3.67833C20.8776 4.23417 21.221 4.7925 21.476 5.45C21.7226 6.08667 21.891 6.81333 21.941 7.8775C21.9885 8.94417 22.001 9.28333 22.001 12C22.001 14.7167 21.991 15.0558 21.941 16.1225C21.8918 17.1867 21.7226 17.9125 21.476 18.55C21.2218 19.2092 20.8776 19.7658 20.3226 20.3217C19.7668 20.8767 19.2076 21.22 18.551 21.475C17.9135 21.7217 17.1876 21.89 16.1235 21.94C15.0568 21.9875 14.7176 22 12.001 22C9.28431 22 8.94514 21.99 7.87848 21.94C6.81431 21.8908 6.08931 21.7217 5.45098 21.475C4.79264 21.2208 4.23514 20.8767 3.67931 20.3217C3.12348 19.7658 2.78098 19.2067 2.52598 18.55C2.27848 17.9125 2.11098 17.1867 2.06098 16.1225C2.01348 15.0558 2.00098 14.7167 2.00098 12C2.00098 9.28333 2.01098 8.94417 2.06098 7.8775C2.11014 6.8125 2.27848 6.0875 2.52598 5.45C2.78014 4.79167 3.12348 4.23417 3.67931 3.67833C4.23514 3.1225 4.79348 2.78 5.45098 2.525C6.08848 2.2775 6.81348 2.11 7.87848 2.06C8.94514 2.0125 9.28431 2 12.001 2Z"
                  fill="rgba(70,146,221,1)"
                ></path>
              </svg>
              <dl className="flex flex-col gap-3">
                <dt className="font-bold text-lg mb-3">
                  <a
                    target="_blank"
                    without
                    rel="noreferrer"
                    href="https://www.instagram.com/llc_unicon.uz/"
                  >
                    Instagram
                  </a>
                </dt>
              </dl>
            </div>
          </div>
        </div>

        <form
          className={
            "card p-16 xl:p-8 w-3/4 lg:w-full flex flex-wrap gap-5 md:gap-3 hover:shadow-2xl"
          }
          style={{ border: "1px solid #abb8c3" }}
        >
          {/* <div className="relative w-full flex-grow sm:w-full duration-300">
            <h2 className="text-xl text-logo font-bold text-center mb-5">
              {t("channels_title")}
            </h2>
          </div> */}
          <div className="relative w-full flex-grow sm:w-full duration-300">
            <label className="text-lg" htmlFor="shaxs">
              {t("person_tip")}: {t("fiz_tip")}/{t("yur_tip")}{" "}
              <span className="text-[red]">*</span>
            </label>
            <select
              id="shaxs"
              required
              value={userType}
              onChange={(e) => setUserType(e.target.value)}
              name="user_type"
              className="text-xl border-logo p-2  border rounded-md  md:p-1 w-full"
            >
              <option value="1">{t("fiz_tip")}</option>
              <option value="2">{t("yur_tip")}</option>
            </select>
          </div>

          <div className="relative w-full flex-grow sm:w-full duration-300">
            <label className="text-lg" htmlFor="shaxs">
              {location === "uz" ? "Murojaat/Ariza" : "Обращение/Приложение"}
              <span className="text-[red]"> *</span>
            </label>
            <select
              id="shaxs"
              required
              value={appealType}
              onChange={(e) => setAppealType(e.target.value)}
              name="appeal_type"
              className="text-xl border-logo p-2  border rounded-md  md:p-1 w-full"
            >
              <option value="1">{location === "uz" ? "Murojaat" : "Обращение"}</option>
              <option value="2">{location === "uz" ? "Ariza" : "Приложение"}</option>
            </select>
          </div>

          <div className="relative w-full flex-grow sm:w-full duration-300">
            <label className="text-lg" htmlFor="shaxs">
              {location === "uz" ? "Bo'lim nomi" : "Название раздела"}
              <span className="text-[red]"> *</span>
            </label>
            <select
              id="shaxs"
              required
              value={branch}
              onChange={(e) => setBranch(e.target.value)}
              name="appeal_type"
              className="text-xl border-logo p-2  border rounded-md  md:p-1 w-full"
            >
              <option value="1">{location === "uz" ? "TTV sertifikatlashtirish idorasi" : "Орган по сертификации ТСТ"}</option>
              <option value="2">{location === "uz" ? "TTV sertifikatlashtirish sinov markazi" : "Сертификационный испытательный центр ТСТ"}</option>
              <option value="3">{location === "uz" ? "TQTT texnik vositalari maxsus sinov laboratoriyasi" : "Специальная испытательная лаборатория технических средств СОРМ"}</option>
              <option value="4">{location === "uz" ? "TQTT texnik vositalarini sertifikatlashtirish maxsus idorasi" : "Специальный орган по сертификации технических средств СОРМ"}</option>
            </select>
          </div>

          <div className="relative w-[40%] flex-grow sm:w-full duration-300">
            <label className="text-lg">
              {t("name")} {t("organization-name")}{" "}
              <span className="text-[red]">*</span>
            </label>
            <input
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="text-xl border-logo p-2  border rounded-md  md:p-1 w-full"
              type="text"
              placeholder={t("fish")}
              name="name"
            />
          </div>

          <div className="relative w-[40%] flex-grow sm:w-full duration-300">
            <label className="text-lg">
              {t("email")} <span className="text-[red]">*</span>
            </label>
            <input
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="text-xl border-logo p-2  border rounded-md  md:p-1 w-full"
              type="email"
              placeholder={t("email")}
              name="email"
            />
          </div>

          <div className="relative w-[40%] flex-grow sm:w-full duration-300">
            <label className="text-lg">
              {t("phone")} <span className="text-[red]">*</span>
            </label>
            <InputMask
              className="text-lg border-logo p-2  border rounded-md  md:p-1 w-full"
              placeholder={t("phone")}
              value={phone_number}
              onChange={(e) => setPhoneNumber(e.target.value)}
              type="tel"
              name="phone_number"
            />
          </div>

          <div className="relative w-[40%] flex-grow sm:w-full duration-300">
            <label className="text-lg">
              {t("address")} <span className="text-[red]">*</span>
            </label>
            <input
              required
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              className="text-xl border-logo p-2  border rounded-md  md:p-1 w-full"
              type="address"
              placeholder={t("address")}
              name="address"
            />
          </div>

          <div className="relative w-[32%] flex-grow sm:w-full duration-300">
            <div className="flex flex-col items-start">
              <label className="mb-2" htmlFor="file1">
                (doc/pdf/docx)
              </label>
              <label className="custom-file-upload">
                <input
                  id="max_id"
                  type="hidden"
                  name="MAX_FILE_SIZE"
                  value="5245880"
                />
                <input
                  className="hidden"
                  required
                  onChange={fileChange}
                  accept=".doc,.pdf,.docx"
                  type="file"
                />
                {/* <img className="mr-2" src={Upload} alt="upload icon" /> */}
                {/* {t("file-upload")} */}
                {location === "uz" ? "Fayl yuklash" : "загрузить файл"}
              </label>
              {fileName}
            </div>
          </div>

          <div className="relative w-full flex-grow sm:w-full duration-300">
            <label className="text-lg">
              {t("message")} <span className="text-[red]">*</span>
            </label>
            <textarea
              required
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="text-lg border-logo p-2  border rounded-md  md:p-1 w-full"
              placeholder={t("text")}
              name={t("message")}
            />
          </div>

          <div className="flex justify-end items-start mb-2">
            <button
              onClick={(event) => {
                event.preventDefault();
                if (!name) {
                  toast.error("Ismingiz yoki tashkilot nomini kiritmadingiz!");
                } else if (!email) {
                  toast.error("Pochtangizni kiritmadingiz!");
                } else if (!address) {
                  toast.error("Manzil kiritmadingiz!");
                } else if (!phone_number) {
                  toast.error("Telefon raqamingizni kiritmadingiz!");
                } else if (!message) {
                  toast.error("Murojaat matnini kiritmadingiz!");
                } else if (!file) {
                  toast.error("File yuklamadingiz!");
                } else {
                  const formData = new FormData();
                  formData.append("person_type", userType);
                  formData.append("appeal_type", appealType);
                  formData.append("branch", branch);
                  formData.append("name", name);
                  formData.append("email", email);
                  formData.append("phone", phone_number);
                  formData.append("address", address);
                  formData.append("letter", message);
                  formData.append("drop_file", file);
                  dispatch(postAppeal(formData));
                  toast.success("Xabaringiz yuborildi tez orada bog'lanamiz");
                  setName("");
                  setEmail("");
                  setPhoneNumber("");
                  setMessage("");
                  setAddress("");
                }
              }}
              type={"submit"}
              className="px-4 py-2 mt-3 rounded-[4px] bg-[#0E0E4B] text-white xs:px-2 xs:py-1 justify-center duration-200 opacity-70 hover:opacity-100"
            >
              {t("send")}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}
